import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class BroadcastProgramStore extends LocalModel {
    constructor() {
        super('broadcastProgram', {
            namePlural: 'broadcastPrograms',
            namePluralReal: 'broadcastprograms',
            sort: 'sortOrder',
            limit: 100,
            api: {
                search: {
                    url: '/api/broadcastprograms/',
                    params: {
                        limit: 100,
                        sort: 'sortOrder',
                    },
                },
                load: {
                    url: '/api/broadcastprograms/',
                    params: {},
                },
                save: {
                    url: '/api/broadcastprograms/',
                    params: {},
                },
                delete: {
                    url: '/api/broadcastprograms/',
                    params: {},
                },
            },
        });
    }

    @observable broadcastProgram = {};

    @observable broadcastPrograms = [];

    async loadPrograms(params = {}) {
        const response = await util.fetchApi('/api/broadcastprograms/', { method: 'GET' }, params);
        if (response.status === 200) {
            this.updateKeyValue('broadcastPrograms', response.data || []);
            return response.data;
        }
        return [];
    }
}

const store = new BroadcastProgramStore();
export default store;
